import { Box, Button, Center, Heading, Text, useToast } from "@chakra-ui/react";
import axios from "axios";
import ResetPasswordForm from "components/Organismos/ResetPasswordForm";
import LoginTemplate from "components/Templates/Login";
import { ResetPasswordFormData } from "models/password-reset.model";
import { Link, useNavigate } from "react-router-dom";
import { resetPasswordRequest } from "store/modules/users/actions/resetPassword";
import { useDispatchToPromise } from "utils/dispatch-to-promise";
import { useQueryParam } from "utils/hooks/useQueryParam";

const ResetPasswordPage = () => {
    const [token] = useQueryParam<string>('token');
    const [userId] = useQueryParam<string>('idUsuario');
    const toast = useToast();
    const dispatchAsPromise = useDispatchToPromise();
    const navigate = useNavigate();

    const handleSubmit = async (data: ResetPasswordFormData) => {
        await dispatchAsPromise(resetPasswordRequest, {
            idUsuario: userId!,
            token: token!,
            newPassword: data.newPassword
        });
        toast({
            status: 'success',
            description: 'Sua senha foi alterada com sucesso! Tente entrar com sua nova senha.'
        });
        navigate('/login');
    }

    const handleFailed = (err: unknown) => {
        if (axios.isAxiosError(err)) {
            if (err.response?.data.usuario && Array.isArray(err.response.data.usuario)) {
                toast({
                    status: 'warning',
                    description: err.response.data.usuario.join('\n')
                });
            } else {
                toast({
                    status: 'warning',
                    description: 'Erro ao entrar no sistema.'
                });
            }
        }
    }

    if (!token || !userId) {
        return (
            <Center h="95vh" flexDirection="column">
                <Heading>Página inválida</Heading>
                <Text>Requisição inválida. Tente clicar novamente no link ou entre em contato com a Administração.</Text>
                <Link to="/login"><Button variant="link" m={4}>Voltar para início</Button></Link>
            </Center>
        )
    }

    return (
        <LoginTemplate
            header={(
                <>
                    <Box px={2}>
                        <Heading>Alteração de senha</Heading>
                        <Text>Informe sua nova senha para alteração.</Text>
                    </Box>
                </>
            )}
            form={(
                <ResetPasswordForm
                    onSuccess={handleSubmit}
                    onFailed={handleFailed}
                />
            )}
            bottomInformation={(
                <></>
            )}
        />
    )
}
export default ResetPasswordPage